<script setup lang="ts">
import {PageHeading} from "@/Components/Global";
</script>

<template>
    <div class="m-container">
        <PageHeading title="Settings" />
    </div>
</template>

<style scoped></style>
